import type { TFunction } from 'i18next';

/** Locale-correct timestamp formatting for the ISO 8601 UTC timestamps the BFF returns (FR48). */
export function formatOrderTimestamp(isoDate: string, locale: string): string {
  return new Date(isoDate).toLocaleString(locale, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

/** fu-7: date-only variant for the order-detail header's "ingediend {{date}}" line — no time. */
export function formatOrderDate(isoDate: string, locale: string): string {
  return new Date(isoDate).toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
}

/** fu-7: compact variant (no year) for the narrow "Laatste event" table column — date and time
 * formatted separately and joined with a space, avoiding the locale's date/time-combo comma
 * (e.g. "15 jul 08:45", not "15 jul, 08:45"). */
export function formatOrderEventTimestamp(isoDate: string, locale: string): string {
  const date = new Date(isoDate);
  const datePart = date.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
  const timePart = date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
  return `${datePart} ${timePart}`;
}

const MS_PER_MINUTE = 60 * 1000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

/**
 * Doorlooptijd (FR15) as a human-readable duration. Coarsest unit that still gives a
 * meaningful reading: days once >= 1 day, else hours, else minutes.
 */
export function formatLeadTime(leadTimeMs: number, t: TFunction): string {
  if (leadTimeMs >= MS_PER_DAY) return t('orders.duration.days', { count: Math.round(leadTimeMs / MS_PER_DAY) });
  if (leadTimeMs >= MS_PER_HOUR) return t('orders.duration.hours', { count: Math.round(leadTimeMs / MS_PER_HOUR) });
  return t('orders.duration.minutes', { count: Math.max(0, Math.round(leadTimeMs / MS_PER_MINUTE)) });
}
